// extracted by css-extract-rspack-plugin
export default {"linkItem":"EducationGroup-module__linkItem__j6O_7"};